import { render, staticRenderFns } from "./TdsIcon.vue?vue&type=template&id=8e617b40&"
import script from "./TdsIcon.vue?vue&type=script&lang=js&"
export * from "./TdsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e617b40')) {
      api.createRecord('8e617b40', component.options)
    } else {
      api.reload('8e617b40', component.options)
    }
    module.hot.accept("./TdsIcon.vue?vue&type=template&id=8e617b40&", function () {
      api.rerender('8e617b40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/accountingreport/TdsIcon.vue"
export default component.exports